import styled from "@emotion/styled";
import { ITEM_HEIGHT } from "client-lib/styles";

export const PageSubheader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: ${ITEM_HEIGHT}px;
`;
